
import React from 'react';
import { FlowRender } from "../flow-render";
import { RadioButton } from "../prm/radio-button";
import { Name } from "../prm/name";
import { Text } from "../prm/text";
import {GreyBox, Info} from "../../client/funcs/utils";
import { CommunityPropertyMenu } from "./community-property-state-menu";
import { UGMAStateMenu2 } from "./ugma-state-menu";
import { Popup } from "../onboarding-shared/popup";
import { onPctAction } from "./co-owner-pct-onAction";
import faker from 'faker';
import { sprintf } from "sprintf-js";
import {INVEST_TYPE, INVEST_FOR, INVEST_FOR_INDEX, IRA_TYPE, AllNames, CREATE_SOURCE_OF_FUNDS_PRM, CUSTODIAL_TYPE} from "./shared-prms";
import { StateOptionMenu } from "../prm/state-menu";
import {SpouseInvestmentAcct, STATE_TO_JOINT_ACCT_TYPE} from "./spouse-investment-acct";
import {dollarToString} from "../currency-utils";
import {InvestmentAccountType} from "../proto/investment_accounts";

const ROTH_IRA_TEXT = "A Roth IRA is available for those that have earned income below the IRS limits.  A Roth IRA provides tax-free growth and since you contribute with after tax dollars, your withdrawals in retirement will be tax free.";
const SPOUSAL_IRA_TEXT = "A Spousal IRA is a strategy that allows a working spouse to contribute to an Individual Retirement Account (IRA) in the name of a non-working spouse who has little or no income. This is an exception to the rule that an individual must have earned income to contribute to an IRA.";
const IRA_TEXT = "A traditional IRA is available to anyone and will provide tax-free growth, allowing qualifying individuals to contribute pre-tax dollars. Withdrawals in retirement will be taxed at ordinary income tax rates.";
const CUSTODIAL_IRA_TEXT = "A Custodial Roth for minors allows children with earned income to invest in a Roth IRA. Contributions are made with after-tax dollars but will grow tax-free, and at retirement, the distributions won't be taxed. An adult acts as custodian until the child reaches adulthood.";

const ROLLOVER_TEXT = [
  // Transfer
  "Transfer an Investment Account, an IRA or an UGMA from " +
  "another firm so we can help you manage your funds",

  // Investment
  "Putting money to work from savings, a bonus, an inheritance, a " +
  "home sale or even a gift and we can help you manage your funds",

  // IRA
  "Start investing for retirement with a tax advantaged "
  + "traditional IRA or a Roth IRA",

  // Rollover
  "Roll over a 401k, a SIMPLE IRA or a SEP IRA into a Rollover "
  + "IRA so as not to trigger a taxable event and to get these "
  + "funds under your control",

  // Trust
  "Open a trust investment account to capture all the gift and "
  + "extra money for a child so that these funds can grow and help "
  + "launch a child into adulthood",

  // standard_invest_1
  "I'd like to take some stock market risk but still want to be "
    + "focused on less volatile investments.",
];

const JOINT_ACCT_ROLLOVER_TEXT = [
  "Assets in these community property states are owned by both "
    + "spouses (50/50).",
  "You reside in an equitable distribution state where each spouse "
    + "is considered to own assets that are titled in his or her name.",
  "Each co-owner owns an equal share of the property without owning any "
    + "specific piece and upon death, property will pass to the "
    + "remaining joint tenant.",
  "When two or more parties have equal or different ownership "
    + "interests and where the ownership share can be bequeathed "
    + "to a named beneficiary upon death.",
];

const MARGIN_TEXT = [
  // Transfer
  "move an account over from another firm",

  // Investment
  "that really takes a stake in my financial future",

  // IRA
  "I need a traditional IRA or a ROTH IRA",

  // Rollover
  "take control of a former employer's retirement plan",

  // Trust
  "put money to work in a UGMA or Custodial Roth",

  // standard_invest_1
  "nothing to risky, just an account to start saving",
]

const IRA_POPUP_TEXT = {
  traditional: IRA_TEXT,
  spousal: SPOUSAL_IRA_TEXT,
  roth: ROTH_IRA_TEXT,
  custodial: CUSTODIAL_IRA_TEXT,
};

const joint_acct_state = new StateOptionMenu(new Name("joint_acct_state"));
const joint_acct_type = new RadioButton(
  new Name("joint_acct_type"), [
    new Name(SpouseInvestmentAcct.COMMUNITY_PROPERTY, "Married Community Property"),
    new Name(SpouseInvestmentAcct.TENANTS_BY_ENTIRETY, "Tenants by Entirety"),
    new Name(SpouseInvestmentAcct.JTWROS, "Joint Tenants With Rights Of Survivorship"),
    new Name(SpouseInvestmentAcct.TENANTS_IN_COMMON, "Tenants in Common"),
  ]);
joint_acct_type.do_checkbox = true;

const filing_status = new RadioButton(
  new Name("filing_status"),
  [
    new Name("single", "Single"),
    new Name("married_joint", "Married Filing Jointly"),
    new Name("married_separate", "Married Filing Separately"),
  ]
);

const community_property_state = new CommunityPropertyMenu(
  new Name("community_property_state"));

const tenants_menu = new RadioButton(
  new Name("tenants"),
  [
    new Name("joint", "Joint Tenants with Rights of Surviorship"),
    new Name("tenants", "Tenants in Common"),
  ]);

const tenant_owner_pct = new Text(
  new Name("tenant_owner_pct"), "50");

const tenant_co_owner_pct = new Text(
  new Name("tenant_co_owner_pct"), "50");

const ugma_state_menu_2 = new UGMAStateMenu2(
  new Name("ugma_state_menu_2"));

const child_age_menu = new Text(
  new Name("child_age_menu"));

const access_funds_years = new Text(AllNames.ACCESS_FUNDS_YEARS_NAME);
const spend_funds_years = new Text(AllNames.SPEND_FUNDS_YEARS_NAME);

const role_0_source_of_funds = CREATE_SOURCE_OF_FUNDS_PRM(AllNames.ROLE_0_SOURCE_OF_FUNDS);
const role_0_other_source = new Text(AllNames.ROLE_0_OTHER_SOURCE);

const rollover_sponsor = new Text(
  new Name("rollover_sponsor", "Name of Employer Sponsoring the Plan"),
  null, { path: "company.companyName" });
const rollover_approx_value = new Text(
  new Name("rollover_approx_value", "Approximate Rollover Amount"));

class InvestFor extends FlowRender {

  constructor(index) {
    super(index, [
      INVEST_FOR,
      INVEST_TYPE,
      IRA_TYPE,
      CUSTODIAL_TYPE,
      filing_status,
      community_property_state,
      tenants_menu,
      tenant_owner_pct,
      tenant_co_owner_pct,
      ugma_state_menu_2,
      child_age_menu,
      access_funds_years,
      spend_funds_years,
      joint_acct_state,
      joint_acct_type,
      role_0_source_of_funds,
      role_0_other_source,
      rollover_sponsor,
      rollover_approx_value,
    ]);
    INVEST_FOR.onChangeCallback = this.onChange;
    CUSTODIAL_TYPE.onChangeCallback = this.onChange;
    INVEST_TYPE.onChangeCallback = this.onChange;
    IRA_TYPE.onChangeCallback = this.onChange;
    tenants_menu.onChangeCallback = this.onChange;
    tenant_owner_pct.onChangeCallback = this.onChange;
    tenant_co_owner_pct.onChangeCallback = this.onChange;
    joint_acct_state.onChangeCallback = this.onChange;
    joint_acct_type.onChangeCallback = this.onChange;

    tenant_owner_pct.onAction = onPctAction(tenant_owner_pct, tenant_co_owner_pct);
    tenant_co_owner_pct.onAction = onPctAction(tenant_owner_pct, tenant_co_owner_pct);

    ugma_state_menu_2.onChangeCallback = this.onChange;

    community_property_state.onMouseEnterCallback = this.onMouseEnter;
    this.url = "invest_for";
  }

  init(componentState, appState) {
    super.init(componentState, appState);
    componentState.invest_for_popup = false;
    componentState.transfer_popup = false;
    componentState.ira_mouse_over = "";
    componentState.joint_text_rollover = -1;
    componentState.nextButtonIsHover = false;
    componentState.backButtonIsHover = false;
  };

  canNavigateBack(component) {
    return false;
  }

  onMouseEnter = (component, enter) => {
    component.setState({
      invest_for_popup: enter,
    });
  }

  onChange = (component, newState, prm) => {
    const tic_selected = joint_acct_type.isSelected(newState, 3);
    tenant_owner_pct.setDisabled(newState, !tic_selected);
    tenant_co_owner_pct.setDisabled(newState, !tic_selected);

    child_age_menu.setValue(
      newState, sprintf("%d", ugma_state_menu_2.getAge(newState)));

    if (INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.standard_invest_1, newState)) {
      access_funds_years.setValue(newState, "4");
      spend_funds_years.setValue(newState, "0");
    } else {
      access_funds_years.setValue(newState, "");
      spend_funds_years.setValue(newState, "");
    }

    if (INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.transfer, newState)) {
      role_0_source_of_funds.setValue(newState, 2, true);
      role_0_other_source.setValue(newState, "Account Transfer");
    } else if (INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.custodial, newState)
        && CUSTODIAL_TYPE.isItemClicked(1, newState)) {
      role_0_source_of_funds.setValue(newState, 0, true);
      role_0_other_source.setValue(newState, "");
    } else {
      role_0_source_of_funds.clear(newState);
      role_0_other_source.setValue(newState, "");
    }


    const active = STATE_TO_JOINT_ACCT_TYPE(joint_acct_state.getValue(newState).id);
    joint_acct_type.buttonList.forEach((name, index) => {
      const is_active = active[name.id.split("|")[1]];
      joint_acct_type.setItemDisabled(index, newState, !is_active);

      // If the user edits the state and the joint_acct_type item is disabled,
      // unselect it
      if (prm === joint_acct_state && !is_active) {
        joint_acct_type.setValue(newState, index, false);
      }
    })
  }

  prmToDelete = state => {
    let prms = [];

    if (INVEST_FOR.getValue(state, true) !== "standard_invest_1") {
      prms = prms.concat("access_funds_years", "spend_funds_years");
    }
    if (INVEST_FOR.getValue(state, true) !== "transfer") {
      prms = prms.concat(AllNames.ROLE_0_SOURCE_OF_FUNDS.id, AllNames.ROLE_0_OTHER_SOURCE.id);
    }
    return prms;
  }

  canNavigateNext(component) {

    const state = component.state;
    const highlight_rects = [];
    let next_endpoint = null;
    let num_roles = 1;
    let role_names = ["Individual"];
    let num_id_docs = 1;
    let num_employment = 1;
    let value;
    const do_kyc = component.getOnboardingData().do_kyc;
    const personal_info_segment = do_kyc ? "/start_kyc" : "/personal_info";
    let account_type;

    if (INVEST_FOR.isFilledElseHighlight(state, highlight_rects, {x: 1.4, y: 1.1})) {
      value = INVEST_FOR.getValue(state, true);

      if (value === 'transfer') {
        next_endpoint = component.getRootUrl() + "/account_transfer";
      } else if (value === 'standard_invest_0' || value === "standard_invest_1") {

        account_type = InvestmentAccountType.individual;
        if (INVEST_TYPE.getValue(state).id === 'spouse'
          && !joint_acct_type.isFilledElseHighlight(state, highlight_rects)) {
          // nothing
          num_roles = 2;
          role_names = [ "Primary", "Spouse"];
        } else {
          next_endpoint = component.getRootUrl() + personal_info_segment;
        }
      } else if (value === 'IRA') {
        if (IRA_TYPE.isFilledElseHighlight(state, highlight_rects)) {

          const is_ira_selected = IRA_TYPE.isItemClicked(0, state);
          const is_spousal_selected = IRA_TYPE.isItemClicked(1, state);
          const is_roth_selected = IRA_TYPE.isItemClicked(2, state);
          const is_custodial_ira_selected = IRA_TYPE.isItemClicked(3, state);

          if (is_ira_selected) {
            account_type = InvestmentAccountType.ira;
          } else if (is_spousal_selected) {
            account_type = InvestmentAccountType.ira;
          } else if (is_roth_selected) {
            account_type = InvestmentAccountType.roth_ira;
          } else if (is_custodial_ira_selected) {
            account_type = InvestmentAccountType.custodial_ira;
          }
          if (is_custodial_ira_selected) {
            num_roles = 2;
            role_names = [ "Custodian", "Minor" ];
            num_id_docs = 2;
            num_employment = 2;
          }
          if (is_roth_selected) {

            if (filing_status.isFilledElseHighlight(state, highlight_rects)) {
              next_endpoint = component.getRootUrl() + personal_info_segment;
            }
          } else {
            next_endpoint = component.getRootUrl() + personal_info_segment;
          }
        }
      } else if (value === "IRA_rollover") {
        const prms = [
          rollover_sponsor,
          rollover_approx_value,
        ];
        prms.forEach(prm => {
          prm.isFilledElseHighlight(state, highlight_rects);
        });
        if (highlight_rects.length === 0) {
          account_type = InvestmentAccountType.rollover_ira;
          next_endpoint = component.getRootUrl() + personal_info_segment;
        }
      } else if (value === 'custodial') {
        if (CUSTODIAL_TYPE.isFilledElseHighlight(state, highlight_rects)) {
          num_roles = 2;
          role_names = [ "Custodian", "Minor" ];
          next_endpoint = component.getRootUrl() + personal_info_segment;
          num_id_docs = 2;
          num_employment = 2;

          const is_ugma = CUSTODIAL_TYPE.isItemClicked(0, state);
          const is_roth = CUSTODIAL_TYPE.isItemClicked(1, state);
          if (is_roth) {
            account_type = InvestmentAccountType.custodial_ira;
          } else if (is_ugma) {
            account_type = InvestmentAccountType.ugma_utma;
          }
        }
      }
    }

    const is_personal_info_endpoint =
      next_endpoint === component.getRootUrl() + personal_info_segment;

    if (highlight_rects.length > 0) {
      component.setState({ highlight_rects });
      return;
    } else {
      if (is_personal_info_endpoint && !component.isBaseAcct() && num_roles === 1) {
        next_endpoint = component.getRootUrl() + "/source_of_funds";
      }
    }

    const new_onboarding = {
      NUM_ROLES: num_roles,
      ROLE_TITLES: role_names,
      NUM_ID_DOCS: num_id_docs,
      NUM_EMPLOYMENT: num_employment,
      account_type: account_type && account_type.id,
    }
    component.writeIfDirty(new_onboarding);
    return next_endpoint;
  }

  setRandomValues(state, component) {
    super.setRandomValues(state);
    ugma_state_menu_2.setRandomValue(state);
    if (INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.standard_invest_0, state)
      || INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.IRA, state)) {
      INVEST_TYPE.setRandomValue(state);

      if (INVEST_TYPE.getValue(state).id === 'spouse') {
        community_property_state.setRandomValue(state);
      } else if (INVEST_TYPE.getValue(state).id === 'tenants_in_common') {
        tenants_menu.setRandomSingleValue(state);
        if (tenants_menu.isItemClicked(1, state)) {
          const rnd_pct = faker.random.number({min: 10, max: 90, precision: 1.});
          tenant_owner_pct.setValue(state, sprintf("%d", rnd_pct));
          tenant_co_owner_pct.setValue(state, sprintf("%d", 100 - rnd_pct));
        }
      }
    } else if (INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.IRA, state)) {
      IRA_TYPE.setRandomSingleValue(state);
    } else if (INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.IRA_rollover, state)) {
      const val = faker.random.number({ min: 10, max: 90, precision: 20 }) * 1000;
      rollover_approx_value.setValue(state, dollarToString(val, true));
    }
  }

  updateNextEndpoint = (component, newState) => {
    const value = INVEST_FOR.getValue(newState, true);

    if (!value) {
      newState.nextEndpoint = "";

    } else if (value === 'transfer') {
      newState.nextEndpoint = component.getRootUrl() + "/account_transfer";

    } else if (value === 'standard_invest_0' || value === 'standard_invest_1') {
      const type_value = INVEST_TYPE.getValue(newState);
      const tenants_value = tenants_menu.getValue(newState);
      if (type_value.id === 'tenants_in_common' && !tenants_value) {
        newState.nextEndpoint = '';
      } else {
        newState.nextEndpoint = component.getRootUrl() + "/personal_info";
      }

    } else if (value === 'IRA') {
      if (!IRA_TYPE.getValue(newState)) {
        newState.nextEndpoint = '';
      } else {
        newState.nextEndpoint = component.getRootUrl() + "/personal_info";
      }

    } else if (value === 'trust') {
      if (child_age_menu.getValue(newState).id === 'na') {
        newState.nextEndpoint = '';
      } else {
        newState.nextEndpoint = component.getRootUrl() + "/personal_info";
      }
    }
  };

  renderCheckboxLabel = (component, index) => {
    const container_style = {
      display: "flex",
      alignItems: "center",
      marginBottom: "0.5rem",
    }
    // const label = INVEST_FOR.buttonList[index].label;
    // const label_style = {
    //   padding: "0.5rem 1rem",
    //   color: "#000",
    //   border: "1px #000 solid",
    //   marginLeft: "1rem",
    //   width: "25rem",
    // }

    // const enter_leave = (enter) => () => {
    //   component.setState({
    //     rollover_text: enter ? index : -1,
    //   })
    // }

    // const popup_style = {
    //   border: "solid 1px black",
    //   color: "black",
    //   padding: "0.5rem 1rem",
    //   width: "30rem",
    //   transform: "translate(25rem, 0rem)",
    // }

    // const popup = component.state.rollover_text === index
    //   ? (
    //     <Popup style={popup_style}>
    //       <span>{ROLLOVER_TEXT[index]}</span>
    //     </Popup>
    //   ) : null;

    // const margin_style = {
    //   flex: "1",
    //   marginLeft: "1rem",
    //   marginTop: "0.5rem",
    // }
    return (
      <div style={container_style}>
        <div>
          { INVEST_FOR.renderRadioLabelInfo(index, component, ROLLOVER_TEXT[index], MARGIN_TEXT[index]) }
          {/* { INVEST_FOR.renderCheckbox(index, component) } */}
        </div>
        {/* { popup } */}
        {/* <div
          style={label_style}
          onMouseLeave={enter_leave(false)}
          onMouseEnter={enter_leave(true)}>
          <span>{ label }</span>
        </div> */}
        {/* <div style={margin_style}>
          { MARGIN_TEXT[index] }
        </div> */}
      </div>
    )
  }

  renderTenantsInCommon = (component) => {
    const divStyle = {
      verticalAlign: "top",
      marginLeft: "1rem",
    };
    const box_style = {
      marginLeft: "1rem",
      marginRight: "1rem",
    };
    const inputStyle = {
      marginLeft: "2rem",
      marginRight: "0.5rem",
      width: "5rem",
      textAlign: "center",
    };
    const co_owner_enable = tenants_menu.isItemClicked(1, component.state);
    const spanStyle = {};
    if (!co_owner_enable) {
      spanStyle.color = "#AAA";
    }
    return (
      <div style={divStyle}>
        <div>
          { tenants_menu.renderCheckboxLabel(0, component, box_style) }
        </div>
        <div>
          { tenants_menu.renderCheckboxLabel(1, component, box_style) }
        </div>
        <div style={{marginTop: "0.5rem"}}>
          { tenant_owner_pct.renderInput(component, inputStyle) }
          <span style={spanStyle}>% Owner</span>
          { tenant_co_owner_pct.renderInput(component, inputStyle) }
          <span style={spanStyle}>% Co-Owner</span>
        </div>
      </div>
    )
  };

  renderJointMenu = (component, is_selected) => {
    const container_style = {
      visibility: is_selected ? "visible" : "hidden",
      display: "flex",
    }
    const active = STATE_TO_JOINT_ACCT_TYPE(joint_acct_state.getValue(component.state).id);

    const enter_leave = (enter, index) => () => {
      component.setState({
        joint_text_rollover: enter ? index : -1,
      })
    }

    const render_item = index => {
      const acct_type = joint_acct_type.buttonList[index].id.split("|")[1];
      const is_active = active[acct_type];
      const item_style = {
        display: "flex",
        alignItems: "center",
        color: is_active ? "#000" : "#999",
      }
      const popup_style = {
        border: "solid 1px black",
        color: "black",
        padding: "0.5rem 1rem",
        width: "30rem",
        transform: "translate(1rem, -5rem)",
      }
      const highlight = component.state.joint_text_rollover === index;
      const popup = highlight
        ? (
          <Popup style={popup_style}>
            <span>{ JOINT_ACCT_ROLLOVER_TEXT[index]}</span>
          </Popup>
        ) : null;
      const label_style = {
        paddingLeft: "1rem",
        fontWeight: highlight ? "bold" : "normal",
      }
      return (
        <div style={item_style} key={index}>
          <div>
            { joint_acct_type.renderCheckbox(index, component)}
          </div>
          { popup }
          <div
            onMouseLeave={enter_leave(false, index)}
            onMouseEnter={enter_leave(true, index)}
            style={label_style}>
            { joint_acct_type.buttonList[index].label }
          </div>
        </div>
      );
    }

    const inputStyle = {
      marginLeft: "2rem",
      marginRight: "0.5rem",
      width: "5rem",
      textAlign: "center",
    };
    const spanStyle = {};
    return (
      <div style={container_style}>
        <div>
          { joint_acct_state.renderMenu(component) }
        </div>
        <div style={{marginLeft: "1rem"}}>
          { [0, 1, 2, 3].map(render_item) }
          <div style={{marginTop: "0.5rem"}}>
            { tenant_owner_pct.renderInput(component, inputStyle) }
            <span style={spanStyle}>% Owner</span>
            { tenant_co_owner_pct.renderInput(component, inputStyle) }
            <span style={spanStyle}>% Co-Owner</span>
          </div>
        </div>
      </div>
    )
  }

  renderInvestType = component => {
    const menuStyle = {
      marginLeft: "2.6rem",
    };
    const spouse_selected =
      INVEST_TYPE.getValue(component.state).id === "spouse";
    return (
      <div style={{display: "flex", paddingBottom: "1rem"}}>
        <div style={{ paddingRight: "2rem", paddingTop: "1rem"}}>
          { INVEST_TYPE.renderMenu(component, menuStyle) }
        </div>
        <div>
          <div style={{height: "1rem"}}/>
          { this.renderJointMenu(component, spouse_selected ) }
          { /* spouse_selected && <span style={spanStyle}>{ community_text }</span> */ }
          { /* spouse_selected && community_property_state.renderMenuDiv(component, commMenuStyle, dropdown) */ }
          { /* this.renderTenantsInCommon(component, tenants_selected) */}
        </div>
      </div>
    );
  };

  renderInvestment = component => {
    return (
      <div>
        { this.renderCheckboxLabel(component, INVEST_FOR_INDEX.standard_invest_0) }
        { /*is_selected && this.renderInvestType(component) */ }
      </div>
    )
  };

  renderFilingStatus = component => {
    // const checkBoxStyle = {
    //   marginLeft: "2rem",
    //   marginRight: "1rem",
    // };
    const render_checkbox_label = (component, index) => {
      return (
        <div style={{paddingTop: "1rem"}}>
          {/* { filing_status.renderCheckbox(index, component, checkBoxStyle) }
          { filing_status.renderLabel(index, component.state) } */}
          {filing_status.renderRadioLabel(index, component)}
        </div>
      );
    };

    return (
      <div style={{paddingLeft: "4rem", paddingTop: "1rem"}}>
        <div>Do you file Taxes as:</div>
        { render_checkbox_label(component, 0) }
        { render_checkbox_label(component, 1) }
        { render_checkbox_label(component, 2) }
      </div>
    )
  };

  renderIRAType = component => {
    const divStyle = {
      marginTop: "1rem",
      marginLeft: "1.6rem",
      marginBottom: "1rem",
    };
    const checkBoxStyle = {
      marginLeft: "2rem",
      marginRight: "1rem",
    };
    const ira_container = {
      marginTop: "1rem",
    };

    const render_checkbox_label = (component, index, id) => {
    //   const label_style = {
    //     display: "inline-block",
    //     marginLeft: "0",
    //   }

      const popup_style = {
        width: "30rem",
      }
      return (
        <div style={ira_container}>
          {/* { IRA_TYPE.renderCheckbox(index, component, checkBoxStyle) }
          { IRA_TYPE.renderLabel(index, component.state, label_style) } */}
          {/* <Info
                id={"info_" + id}
                component={component}
                popup_style={popup_style}
                text={IRA_POPUP_TEXT[id]}
            /> */}

          <div style={{ display: 'flex', ...checkBoxStyle }}>
            { IRA_TYPE.renderRadioLabel(index, component, undefined, { gap: '8px' })}
            <Info
                id={"info_" + id}
                component={component}
                popup_style={popup_style}
                text={IRA_POPUP_TEXT[id]}
            />
          </div>
        </div>
      )
    };

    const is_roth_selected = IRA_TYPE.isItemClicked(2, component.state);
    const is_custodial_selected = IRA_TYPE.isItemClicked(3, component.state);

    return (
      <div style={divStyle}>
        { render_checkbox_label(component, 0, "traditional")}
        { /* render_checkbox_label(component, 1, "spousal") */}
        { render_checkbox_label(component, 2, "roth")}
        { is_roth_selected && this.renderFilingStatus(component) }
        { render_checkbox_label(component, 3, "custodial")}
        { is_custodial_selected && this.renderStateMinorAge(component, false) }
      </div>
    );
  };

  renderIRA = component => {
    const is_selected =
      INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.IRA, component.state);
    return (
      <div>
        { this.renderCheckboxLabel(component, INVEST_FOR_INDEX.IRA) }
        { is_selected && this.renderIRAType(component) }
      </div>
    )
  };

  rollOverDetails = component => {
    const container_style = {
      marginLeft: "4rem",
      marginBottom: "2rem",
    }
    const input_style = {
      marginBottom: "0.5rem",
    }
    return (
      <div style={container_style}>
        { rollover_sponsor.renderInputDiv(component, input_style, rollover_sponsor.name.label) }
        { rollover_approx_value.renderInputDiv(component, input_style, rollover_approx_value.name.label) }
      </div>
    )
  }

  renderRollover = component => {
    const is_selected =
      INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.IRA_rollover, component.state);
    return (
      <div>
        {this.renderCheckboxLabel(component, INVEST_FOR_INDEX.IRA_rollover) }
        { is_selected && this.rollOverDetails(component) }
      </div>
    )



  }

  renderStateMinorAge = (component, is_ugma) => {
    const divStyle = {
      marginTop: "1rem",
      marginLeft: "3rem",
      marginBottom: "1rem",
    };

    const age = ugma_state_menu_2.getAge(component.state);

    const age_style = {
      padding: "0.2rem 1rem",
      marginLeft: "1rem",
      border: "1px solid black",
      fontWeight: "bold",
    }
    const age_elem = (
      <span style={age_style}>{age}</span>
    )
    const ugma_string = is_ugma ? " UGMA" : "";

    return (
      <div style={divStyle}>
        <div>
          <span style={{paddingRight: "1rem"}}>State:</span>
          { ugma_state_menu_2.renderMenu(component, {}) }
        </div>
        <div style={{height: "1rem"}}/>
        <div>
          <span>The age the child will take control of the{ugma_string} Account:</span>
          { age_elem }
        </div>
      </div>
    )
  }

  renderCustodial = component => {
    const is_selected = INVEST_FOR.isItemClicked(INVEST_FOR_INDEX.custodial, component.state);
    const utma_selected = CUSTODIAL_TYPE.isItemClicked(0, component.state);
    const roth_selected = CUSTODIAL_TYPE.isItemClicked(1, component.state);

    const renderCheckboxLabel = (prm, index) => {
    //   const span_style = {
    //     marginLeft: "1rem",
    //   }
      return (
        <div style={{display: "flex", alignItems: "center", paddingTop: "1rem"}}>
          {/* <div>
            { prm.renderCheckbox(index, component) }
          </div>
          <div>
            { prm.renderLabel(index, component.state, span_style) }
          </div> */}
          {prm.renderRadioLabel(index, component)}
        </div>
      )
    }

    const cust_div = (
      <div style={{marginLeft: "2rem"}}>
        {renderCheckboxLabel(CUSTODIAL_TYPE, 0)}
        { utma_selected && this.renderStateMinorAge(component, true) }
        {renderCheckboxLabel(CUSTODIAL_TYPE, 1)}
        { roth_selected && this.renderStateMinorAge(component, false) }
        <div style={{height: "1rem"}}/>
      </div>
    );

    return (
      <div>
        {this.renderCheckboxLabel(component, INVEST_FOR_INDEX.custodial)}
        { is_selected && cust_div }
      </div>
    )
  };

  renderBody = component => {
    return (
      <div>
        <div style={{height: "1rem"}}/>
        <GreyBox>
          { this.renderInvestment(component) }
          { this.renderIRA(component) }
          { this.renderRollover(component) }
          { this.renderCustodial(component) }
          { this.renderCheckboxLabel(component, INVEST_FOR_INDEX.transfer) }
        </GreyBox>
      </div>
    );
  };

  render = component => {
    const width = "60%";
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Welcome", width) }
        { this.renderProgress(component, width) }
        { this.renderSingleColumn(this.renderBody(component), width)}
        { this.renderNextButtonRow(component) }
      </div>
    )
  }
}

export { InvestFor };
